(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/users/';

        return $resource(resourceUrl, {}, {
            'searchCollecteur': { method: 'GET', url :'api/users/searchCollecteur', isArray: true},
            'searchUserArea': { method: 'GET', url :'api/users/searchUserCurrentArea', isArray: true},
            'searchUserByArea': { method: 'GET', url :'api/users/searchUserByArea', isArray: true}
            
        });
    }
})();
